export default "__VITE_ASSET__fa709922__"